import React from 'react';

const IconHeart = ({ className, isFilled }) => {
  return (
    <svg
      className={className}
      width="20"
      height="18"
      viewBox="0 0 20 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 17.77l-1.42-1.29C3.4 11.82 0 8.79 0 5.09 0 2.06 2.42-.32 5.45-.32c1.74 0 3.41.81 4.55 2.09C11.14.49 12.81-.32 14.55-.32 17.58-.32 20 2.06 20 5.09c0 3.7-3.4 6.73-8.58 11.39L10 17.77z"
        fill={isFilled ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth={isFilled ? '0' : '1.5'}
      />
    </svg>
  );
};

export default IconHeart;
